export default "__VITE_ASSET__DDQzjUIN__"